import {Box, Button, Typography} from "@mui/material";
import {FC, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {LoadingComponent} from '../../components/LoadingComponent';
import {useAuth} from "../../firebase/firebaseAuth";
import {I18Picker} from "../../components/I18Picker/I18Picker";
import {useTranslation} from "react-i18next";
import {UserDetailsForm} from "./UserDetailsForm";

type Props = {
  onUpdate?: () => void,
  showBetaButton?: boolean
}

export const UserDetailsPage: FC<Props> = ({onUpdate}) => {
  const {t} = useTranslation();
  const {userData, updateUserData} = useAuth()
  const navigate = useNavigate()

  const [data, setData] = useState(userData)
  const [isSaving, setSaving] = useState(false)
  const [error, setError] = useState<string>()

  const saveIfValuesAreNotEmpty = () => {
    if (data?.name && data?.birthYear > 0 && data?.sex) {
      setSaving(true)
      updateUserData(data,).then(() => setSaving(false)).then(() => {
          if (onUpdate != null) {
            onUpdate()
          } else {
            navigate("/")
          }
        }
      )
    } else {
      setError(t('user.fillAllFields') || "error")
    }
  }

  useEffect(() => {
    setData(userData)
  }, [userData])

  if (data) {
    return (
      <>
        <Box component="form" sx={{display: "flex", alignItems: "center", flexDirection: "column",}}>
          <Typography align="center" variant="h4">{t('user.yourData')}</Typography>
          <UserDetailsForm userBasicData={{name: data.name, birthYear: data.birthYear, sex: data.sex}}
                           onChange={basicData => setData({...data, ...basicData})} setError={setError} error={error}/>
          <I18Picker/>
          <Button variant="contained" disabled={isSaving} sx={{mt: 2, p: 2, pr: 4, pl: 4}}
                  onClick={() => saveIfValuesAreNotEmpty()}>{t('save')}</Button>
          <Typography color="error" sx={{display: "block", mt: 2}}>{error || ""}</Typography>
          <Typography>{isSaving ? t("saving") : ""}</Typography>
        </Box>
      </>
    )
  } else {
    return <LoadingComponent message={t("loading.data")}/>
  }
};